"use client"
import { useSession } from "next-auth/react"
import { usePathname, useRouter } from "next/navigation"
import { useEffect } from "react"

export function AuthRedirect() {
  const { data: session, status } = useSession()
  const pathname = usePathname()
  const router = useRouter()
  useEffect(() => {
    if (status !== "authenticated") return
    if (session?.user?.role !== 'ADMIN' && session?.user?.needsCompletion && pathname !== "/completar-cadastro") {
      router.replace("/completar-cadastro")
    }
  }, [session, status, pathname, router])
  return null
} 